export enum FiltersName {
    User = 'username',
    Marketer = 'marketerCode',
    Filter = 'filter'
}